/*
 * Segnala al server gli errori del flusso di pagamento (finiscono nel log Serilog
 * con prefisso [CLIENT]). Non blocca mai l'utente: errori di invio ignorati.
 * Categorie ammesse (vedi ClientErrorController): invio_ordine, avvio_pagamento,
 * tracking, esito_ok, articolo_non_disponibile, pagina_ko.
 * Non inviare dati personali del cliente nel messaggio.
 */
export function reportClientError(codiceNoleggio, categoria, messaggio, codiceOrdine) {
  try {
    const testo =
      messaggio instanceof Error
        ? `${messaggio.name}: ${messaggio.message}`
        : String(messaggio ?? "");

    // eslint-disable-next-line no-console
    console.error(`[${categoria}]`, testo);

    if (!codiceNoleggio) return;

    fetch(
      `${process.env.REACT_APP_NPURL}/api/shop/${encodeURIComponent(
        codiceNoleggio
      )}/erroreclient`,
      {
        method: "POST",
        keepalive: true, // arriva anche se la pagina sta per fare il redirect
        headers: {
          "Content-Type": "application/json",
          ApiKey: process.env.REACT_APP_APIKEY,
        },
        body: JSON.stringify({
          categoria,
          messaggio: testo.slice(0, 500),
          codiceOrdine: codiceOrdine || null,
        }),
      }
    ).catch(() => {});
  } catch (e) {
    // mai propagare errori dalla segnalazione
  }
}
